import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { SubscriptionsTable } from "features/subscription/SubscriptionsTable";
import { _ } from "i18n";
import { useEffect } from "react";
import { Link } from "react-router";
import "style/discoverPage.css";

export function SubscriptionListPage() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	return (
		<div className="discover-container discover-container--wide">
			<div className="pageHeading" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<h1>{_("label.subscriptions_management")}</h1>
				<Link to="/subscription/new" className="btn btn-light-blue">
					+ {_("label.add.subscription")}
				</Link>
			</div>
			<SubscriptionsTable />
		</div>
	);
}

export default SubscriptionListPage;
